// extracted by mini-css-extract-plugin
export default {"root":"PlasmicPageInfoLine_root__c7K2o","text":"PlasmicPageInfoLine_text__MBEvC"};